import axios, { AxiosResponse } from 'axios';
import { TempWorker } from '../materials/tempWorkers';
import { apiClient } from '../apiClient';

export interface DailyTempWorker {
    _id: string;
    activityId: string;
    tempWorkerTypeId: TempWorker;
    durationDay: number;
    durationHours?: number;
    tempWorkerName?: string;
    state: number;
    includedInExpenses?: boolean;
    price?: number;
    priceType?: number;
    unitPrice?: number;
}

export interface DeleteDailyTempWorkerResponse {
    message: string;
    data: DailyTempWorker;
}

export const deleteDailyTempWorker = async (id: string): Promise<DeleteDailyTempWorkerResponse> => {
    try {
        const response: AxiosResponse<DeleteDailyTempWorkerResponse> = await apiClient.delete(`/daily-tempworkers/${id}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface CreateDailyTempWorkerResponse {
    message: string;
    data: DailyTempWorker;
}

export interface CreateDailyTempWorkerBody {
    activityId: string;
    tempWorkerTypeId: string;
    durationHours?: number;
    tempWorkerName?: string;
    price?: number;
    priceType?: number;
    includedInExpenses?: boolean;
    unitPrice?: number;
}

export const createDailyTempWorker = async (body: CreateDailyTempWorkerBody): Promise<CreateDailyTempWorkerResponse> => {
    try {
        const response: AxiosResponse<CreateDailyTempWorkerResponse> = await apiClient.post('/daily-tempworkers', body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface DailyTempWorkerResponse {
    message: string;
    data: DailyTempWorker;
}

export interface UpdateDailyTempWorkerBody {
    activityId?: string;
    tempWorkerTypeId?: string;
    durationDay?: number;
    state?: number;
    durationHours?: number;
    tempWorkerName?: string;
    price?: number | null;
    priceType?: number | null;
    includedInExpenses?: boolean;
    unitPrice?: number | null;
}

export const updateDailyTempWorker = async (id: string, body: UpdateDailyTempWorkerBody): Promise<DailyTempWorkerResponse> => {
    try {
        const response: AxiosResponse<DailyTempWorkerResponse> = await apiClient.patch('/daily-tempworkers/' + id, body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
